import { useEffect, useState } from "react";

import OkcApi from "shared/util/OkcApi";
import _str from "shared/util/_str";

const USER_CACHE = {};
const PROFILE_FIELDS = [
	"thumbs.limit(1)",
	"userinfo",
	"percentages",
	"detail_tags",
];

export default ({
	triggerLoadUser,
	setTriggerLoadUser,
	userId,
	setUserData,
	setError,
}) => {
	const [apiResponse, setApiResponse] = useState(null);

	// watch for trigger load user to start an api call
	useEffect(() => {
		if (!triggerLoadUser || !userId) {
			return;
		}

		setTriggerLoadUser(false);

		if (USER_CACHE[userId]) {
			setUserData(USER_CACHE[userId]);
			return;
		}

		OkcApi.get(`/profile/${userId}/fields`, {
			data: {
				fields: PROFILE_FIELDS.join(","),
				action: "quickview",
			},
		}).then((res) => {
			setApiResponse(res);
		}).catch(() => {
			setUserData(null);
			setError(_str("There was a problem loading more info!"));
		});
	}, [
		triggerLoadUser,
		setTriggerLoadUser,
		userId,
		setUserData,
		setError,
	]);

	// watch for an api response, put it in the cache, and set it to display
	// if appropriate
	useEffect(() => {
		if (!apiResponse || !apiResponse.userid) {
			return;
		}

		USER_CACHE[apiResponse.userid] = apiResponse;

		if (apiResponse.userid === userId) {
			setUserData(apiResponse);
		}
	}, [apiResponse, userId, setUserData]);
};



// WEBPACK FOOTER //
// ./src/shared/components/ProfileQuickview/hooks/useLoadUser.js